module.exports = __webpack_public_path__ + "media/images/bg/hero-6164799384e0d692819158ab08a91249.svg";